import React from 'react'
import Header from '../_components/common/Header'
import ReportExportUI from '../_components/UI/ReportExportUI'

const ReportExport = () => {
  return (
    <div className='page-main'> 
        <Header name = {["Report Export"]} />
        <ReportExportUI />
    </div>
  )
}

export default ReportExport